import * as React from "react"
import styles from "./Export.module.scss"
import {useContext, useEffect, useRef} from "react";
import {getCurrentFilters} from "../../../util/currentFiltersHelper";
import appContext from "../../../context/appContext";
import apiExportDataframe from "../../../services/api/apiExportDataframe";
import {useHistory, useLocation} from "react-router-dom";
import { Canvg } from "canvg";

const formats = [
  {
    title: "EXCEL",
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5862 2.29192H6.37866C3.86616 2.29192 2.29199 4.07025 2.29199 6.58692V13.3777C2.29199 15.8944 3.85949 17.6727 6.37866 17.6727H13.5853C16.1053 17.6727 17.6728 15.8944 17.6728 13.3777V6.58692C17.6728 4.07025 16.1053 2.29192 13.5862 2.29192Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.91958 7.32125C8.91958 8.17041 8.23042 8.85958 7.38125 8.85958C6.53292 8.85958 5.84375 8.17041 5.84375 7.32125C5.84375 6.47208 6.53292 5.78291 7.38125 5.78291C8.23042 5.78291 8.91958 6.47208 8.91958 7.32125Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.6723 12.4587C16.8439 11.7379 16.1231 10.8704 15.1731 10.2979C14.2214 9.72542 13.1989 10.0787 12.5389 10.9329C11.9014 11.7587 11.5031 12.8696 10.5406 13.3904C9.35476 14.0329 8.65809 12.9971 7.66892 12.5821C6.56476 12.1196 5.72642 12.9512 5.08142 13.7504C4.43559 14.5504 3.78142 15.3421 3.12476 16.1337" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>,
  },
  {
    title: "CSV",
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5862 2.29192H6.37866C3.86616 2.29192 2.29199 4.07025 2.29199 6.58692V13.3777C2.29199 15.8944 3.85949 17.6727 6.37866 17.6727H13.5853C16.1053 17.6727 17.6728 15.8944 17.6728 13.3777V6.58692C17.6728 4.07025 16.1053 2.29192 13.5862 2.29192Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.91958 7.32125C8.91958 8.17041 8.23042 8.85958 7.38125 8.85958C6.53292 8.85958 5.84375 8.17041 5.84375 7.32125C5.84375 6.47208 6.53292 5.78291 7.38125 5.78291C8.23042 5.78291 8.91958 6.47208 8.91958 7.32125Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.6723 12.4587C16.8439 11.7379 16.1231 10.8704 15.1731 10.2979C14.2214 9.72542 13.1989 10.0787 12.5389 10.9329C11.9014 11.7587 11.5031 12.8696 10.5406 13.3904C9.35476 14.0329 8.65809 12.9971 7.66892 12.5821C6.56476 12.1196 5.72642 12.9512 5.08142 13.7504C4.43559 14.5504 3.78142 15.3421 3.12476 16.1337" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  },
  {
    title: "JPG",
    icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5862 2.29192H6.37866C3.86616 2.29192 2.29199 4.07025 2.29199 6.58692V13.3777C2.29199 15.8944 3.85949 17.6727 6.37866 17.6727H13.5853C16.1053 17.6727 17.6728 15.8944 17.6728 13.3777V6.58692C17.6728 4.07025 16.1053 2.29192 13.5862 2.29192Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.91958 7.32125C8.91958 8.17041 8.23042 8.85958 7.38125 8.85958C6.53292 8.85958 5.84375 8.17041 5.84375 7.32125C5.84375 6.47208 6.53292 5.78291 7.38125 5.78291C8.23042 5.78291 8.91958 6.47208 8.91958 7.32125Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.6723 12.4587C16.8439 11.7379 16.1231 10.8704 15.1731 10.2979C14.2214 9.72542 13.1989 10.0787 12.5389 10.9329C11.9014 11.7587 11.5031 12.8696 10.5406 13.3904C9.35476 14.0329 8.65809 12.9971 7.66892 12.5821C6.56476 12.1196 5.72642 12.9512 5.08142 13.7504C4.43559 14.5504 3.78142 15.3421 3.12476 16.1337" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  }
]

const Export = ({Viewer}) => {
  const [showDropdown, setShowDropdown] = React.useState(false)
  const [progress, setProgress] = React.useState(null)
  const dropdownRef = useRef(null)

  // const canvas = document.querySelector(".vis-network canvas");
  // const link  = document.createElement('a');
  // link.href = canvas.toDataURL({pixelRatio: 10});
  // link.download = 'Image.jpg';
  // link.click();







  const exportAsJpeg = async () => {
    const graphGroup = document.querySelector("#main-svg-viewer svg");
    // const graphGroup = Viewer.current;
    if (!graphGroup) return console.error("graph0 not found");

    const svgElement = graphGroup.closest("svg"); // ✅ کل SVG
    if (!svgElement) return console.error("SVG not found");

    const fileName = "image.jpg";
    const scale = 4;
    const quality = 0.92;

    const cloned = svgElement.cloneNode(true);

    // سایز/ویوباکس
    const vb = svgElement.viewBox?.baseVal;
    const w = vb?.width || svgElement.getBoundingClientRect().width || 1000;
    const h = vb?.height || svgElement.getBoundingClientRect().height || 1000;

    cloned.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    cloned.setAttribute("width", w);
    cloned.setAttribute("height", h);
    if (!cloned.getAttribute("viewBox") && vb) {
      cloned.setAttribute("viewBox", `${vb.x} ${vb.y} ${vb.width} ${vb.height}`);
    }

    const svgString = new XMLSerializer().serializeToString(cloned);

    const canvas = document.createElement("canvas");
    canvas.width = Math.round(w * scale);
    canvas.height = Math.round(h * scale);

    const ctx = canvas.getContext("2d");

    // render با scale
    ctx.setTransform(scale, 0, 0, scale, 0, 0);

    const v = await Canvg.fromString(ctx, svgString, {
      ignoreMouse: true,
      ignoreAnimation: true,
      // اگر نسخه‌ات ساپورت کنه، این عالیه:
      // ignoreClear: true,
    });

    await v.render();

    // ✅ بکگراند سفید *بعد* از render (تا اگر canvg پاک کرد، بازم سفید بشه)
    ctx.globalCompositeOperation = "destination-over";
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = "source-over";

    const jpgUrl = canvas.toDataURL("image/jpeg", quality);

    const a = document.createElement("a");
    a.href = jpgUrl;
    a.download = fileName;
    a.click();
  };


  const handleOutsideClick = e => {
    if (!dropdownRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener("click", handleOutsideClick, false);
    }
    return function cleanupListener() {
      document.removeEventListener('click', handleOutsideClick, false)
    }
  }, [showDropdown]);

  const context = useContext(appContext)

  let analysisId = null;
  if (context.handleUid().id) {
    analysisId = context.handleUid().id;
  }

  const location = useLocation()

  const handleGetExportedFile = (format, fileNameExtension) => {
    const filtersData = getCurrentFilters(context, location.pathname)
    apiExportDataframe.postSingle(`${analysisId}/${format}`, filtersData, {responseType: 'arraybuffer',
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
        if (totalLength !== null) {
          setProgress({loaded: Math.round((progressEvent.loaded * 100) / totalLength), format: format.toUpperCase()});
        }
      },
    }).then(res => {
      const outputFilename = `${Date.now()}.${fileNameExtension}`;
      const url = URL.createObjectURL(new Blob([res.response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
      setProgress(null)
    })
  }

  const handleExport = (format) => {
    switch (format) {
      case "EXCEL":
        handleGetExportedFile('excel', 'xlsx')
        break
      case "CSV":
        handleGetExportedFile('csv', 'csv')
        break
      case "JPG":
        exportAsJpeg()
        break
      default:
        break;
    }
  }

  const history = useHistory()

  return (
    <div className={[styles.Export, history.location?.search === "?view=side-by-side" ? styles.sideBySideMode : null].join(" ")}>
      <div className={styles.exportButton} onClick={() => setShowDropdown(!showDropdown)}>
        <i>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.1222 15.4361L12.1222 3.3951" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M15.0382 12.5084L12.1222 15.4364L9.20619 12.5084" stroke="#0A195C" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <path
              d="M16.755 8.12799H17.688C19.723 8.12799 21.372 9.77699 21.372 11.813V16.697C21.372 18.727 19.727 20.372 17.697 20.372L6.55699 20.372C4.52199 20.372 2.87199 18.722 2.87199 16.687V11.802C2.87199 9.77299 4.51799 8.12799 6.54699 8.12799L7.48899 8.12799"
              stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </i>
      </div>
      {
        <div ref={dropdownRef} className={`${styles.dropdown} ${showDropdown && styles.show}`}>
          {formats.map(format =>
            progress?.format === format.title ?
              <div className={[styles.item, styles.progressbar].join(" ")}>
                Loading...
              </div>
              : <div className={`d-flex cursor-pointer ${styles.item}`} onClick={() => handleExport(format.title)}>
                <span className={'d-flex align-items-center'}>{format.icon}</span>
                <span className={'d-flex align-items-center'}>{format.title}</span>
              </div>
          )}
        </div>
      }

    </div>
  )
}

export default Export